const remove = (item, list) => {
  const listCopy = [...list]
  const index = list.findIndex(i => JSON.stringify(i) === JSON.stringify(item))
  listCopy.splice(index, 1)
  return listCopy
}

export default remove
